import React, { useState, useEffect } from "react";
import CallIcon from "@mui/icons-material/Call";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./EditPassword.css";
import axios from "axios";

function EditPassword() {
  const [orderSummary, setOrderSummary] = useState([]);
  const [pwdMatch, setPwdMatch] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const email = JSON.parse(localStorage.getItem("email"));
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerProfileInfo?email=` + email, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setOrderSummary(response.data.data[0]);
          } else {
            console.error(
              "Invalid token or expired session:",
              response.data.message
            );
            // Handle invalid token scenario
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  const [formData, setFormData] = useState({
    current_password: "",
    password: "",
    recheck_password: "",
  });

  const [pwdData, setPwdData] = useState({
    current_password: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setPwdData({
      ...pwdData,
      [name]: value,
    });

    if (name === "recheck_password") {
      if (value !== formData.password) {
        setPwdMatch("Passwords don't match");
      } else {
        setPwdMatch("Passwords match");
      }
    }

    if (name === "current_password") {
      setErrorMessage("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.current_password) {
      setErrorMessage("Current Password is required.");
      alert("Current Password is required");
      return;
    }

    if (formData.password === formData.recheck_password) {
      try {
        const storedToken = JSON.parse(localStorage.getItem("accessToken"));
        const response = await axios.post(
          `${baseAPI}customerpost/UpdateCustomerPassword`,
          pwdData, // Send request body
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        setFormData({
          current_password: "",
          password: "",
          recheck_password: "",
        });
      } catch (error) {
        console.error("Error posting data:", error);
      }
    } else {
      alert("Passwords don't match");
    }
  };

  return (
    <div>
      <div className="customer-edit-main  py-5">
        <div className="row container-fluid p-0">
          <div className="col-7 p-0 customer-edit-img-div d-flex justify-content-start align-items-center edit-profile-mobile-view-hide">
            <div className="customer-icon">
              <PersonOutlineIcon className="" />
            </div>
            <div className="customer-edit-img-div-content">
              <h5>
                {orderSummary.First_Name} {orderSummary.Last_Name}
              </h5>
              <h6>{orderSummary.Email}</h6>
            </div>
          </div>
          <div className="col-12 px-3 customer-edit-img-div d-flex justify-content-start align-items-center edit-profile-mobile-view-show">
            <div className="customer-icon">
              <PersonOutlineIcon className="" />
            </div>
            <div className="customer-edit-img-div-content">
              <h5>Vasant Mahajan</h5>
              <h6>Customer ID - 51098</h6>
            </div>
          </div>
        </div>
        <form className="relocation-details-main-form px-2 py-2">
          <div className="form-row row align-items-center ">
            <div className="col-md-4 col-8">
              <label
                style={{ color: "#6a6a6a", marginTop: "29px" }}
                className=""
                htmlFor=""
              >
                Current Password
              </label>
              <input
                style={{
                  border: "1px solid #5B489D",

                  paddingLeft: "10px",
                  width: "100%",
                }}
                type="password"
                className="form-control m-0"
                placeholder="Enter"
                name="current_password"
                value={formData.current_password}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row row align-items-center">
            <div className="col-md-4 col-8">
              <label
                style={{ color: "#6a6a6a", marginTop: "29px" }}
                className=""
                htmlFor=""
              >
                New Password
              </label>
              <input
                style={{
                  border: "1px solid #5B489D",

                  paddingLeft: "10px",
                  width: "100%",
                }}
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-control m-0"
                placeholder="Enter"
              />
            </div>
          </div>

          <div className="form-row row align-items-center">
            <div className="col-md-4 col-8">
              <label
                style={{ color: "#6a6a6a", marginTop: "29px" }}
                className=""
                htmlFor=""
              >
                Confirm New Password
              </label>
              <input
                style={{
                  border: "1px solid #5B489D",

                  paddingLeft: "10px",
                  width: "100%",
                }}
                className="form-control m-0"
                placeholder="Enter"
                type="password"
                name="recheck_password"
                value={formData.recheck_password}
                onChange={handleChange}
              />
            </div>
          </div>

          <hr style={{ marginTop: "46px" }} />

          <div
            style={{ textAlign: "end" }}
            className="customer-profile-bottom-button-div edit-profile-btn-mobile-view-show m-0 mt-4 px-2"
          >
            <button
              style={{
                textAlign: "center",
                fontSize: "14px",
                color: "#F15843",
                border: "none",
                width: "93px",
              }}
              type=""
              className="btn customer-profile-cancel-btn"
            >
              Cancel
            </button>
            <button
              style={{
                color: "white",
                fontSize: "14px",
                backgroundColor: "#5B489D",
              }}
              type="submit"
              className="btn customer-profile-save-btn"
            >
              Save
            </button>
          </div>
          <div
            style={{ textAlign: "start" }}
            className="customer-profile-bottom-button-div mt-4 edit-profile-btn-mobile-view-hide"
          >
            <button
              style={{
                color: "white",
                fontSize: "16px",
                backgroundColor: "#5B489D",
              }}
              type="submit"
              className="btn customer-profile-save-btn"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              style={{
                textAlign: "center",
                fontSize: "16px",
                color: "#F15843",
                border: "none",
              }}
              type=""
              className="btn customer-profile-cancel-btn"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditPassword;
